var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "logout",
    style: {
      fill: "#FFFFFF"
    },
    d: "M1.4,18.5c0.6,0.6,1.5,0.6,2.1,0l0,0l6.5-6.4l6.5,6.5c0.3,0.3,0.6,0.4,1,0.4 s0.8-0.2,1-0.4c0.6-0.6,0.6-1.5,0-2c0,0,0,0,0-0.1L12.1,10l6.5-6.5c0.3-0.3,0.4-0.6,0.4-1s-0.2-0.8-0.4-1c-0.6-0.6-1.5-0.6-2-0.1 c0,0,0,0-0.1,0.1L10,7.9L3.5,1.4C3.2,1.1,2.9,1,2.5,1s-0.8,0.2-1,0.4C0.9,2,0.9,2.9,1.5,3.5l0,0L7.9,10l-6.5,6.5 c-0.3,0.3-0.4,0.6-0.4,1S1.2,18.3,1.4,18.5z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.9100221050a420263aa800cfe6bac10e.svg";
export { ForwardRef as ReactComponent };